import React, { useState } from "react";
import { MenuProps } from "antd";
import {
  ToolOutlined,
  FileDoneOutlined,
  HomeOutlined,
  PoweroffOutlined,
  HighlightOutlined,
  CalendarOutlined,
  FileSearchOutlined,
  BuildOutlined,
  IdcardOutlined,
  DeliveredProcedureOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";

import { useNavigate } from "react-router-dom";
import Logo from "../Shared/Logo";
import { useDispatch } from "react-redux";
import { actions } from "../../authentication/services/redux/actions";

type MenuItem = Required<MenuProps>["items"][number];

const { Sider } = Layout;

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  style?: any
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    style,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem("Home", "/", <HomeOutlined />),
  getItem("Checklist", "sub1", <FileDoneOutlined />, [
    getItem("Tickets", "/checklist", <IdcardOutlined />),
    getItem("Calendário", "/calendario", <CalendarOutlined />),
  ]),
  getItem("Medição", "sub2", <HighlightOutlined />, [
    getItem("Tickets", "/medicao", <IdcardOutlined />),
  ]),
  getItem("Montagem", "sub3", <BuildOutlined />, [
    getItem("Tickets", "/montagem", <IdcardOutlined />),
    getItem("Calendário", "/calendario-montadores", <CalendarOutlined />),
  ]),
  getItem("Relatórios", "/relatorios", <FileSearchOutlined />),
  getItem("Frete", "/frete", <DeliveredProcedureOutlined />),
  getItem("Regiões", "/regioes", <GlobalOutlined />),

  getItem("Configurações", "sub4", <ToolOutlined />, [
    getItem("Meu Perfil", "perfil"),
    getItem("Montadores", "montadores"),
    getItem("Usuários", "usuarios"),
  ]),
  getItem("Sair", "logout", <PoweroffOutlined />, undefined, {
    position: "absolute",
    bottom: "3rem",
    zIndex: 1,
    transition: "all 0.2s",
  }),
];

function MainMenu() {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [menuCollapsed, setMenuCollapsed] = useState(false);

  const handleNavigation = (key: string) => {
    if (key === "logout") return dispatch({ type: actions.LOGOUT });
    navigation(key);
  };

  return (
    <Sider
      collapsible
      collapsed={menuCollapsed}
      onCollapse={(value) => setMenuCollapsed(value)}
    >
      <div className="flex justify-center mt-3 ">
        <Logo />
      </div>
      <Menu
        theme="dark"
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={items}
        onClick={({ key }) => handleNavigation(key)}
      />
    </Sider>
  );
}

export default MainMenu;
